export default "__VITE_ASSET__896bf943__"